import { useEffect } from "preact/hooks";
import { dismissErrors, errors } from "~/web/src/errors";
import { navigate } from "~/web/src/router";

// Renders while the error queue is non-empty; Dismiss or Escape clears it. The first entry
// names the heading; an entry's call to action (one button, before Dismiss) goes to its page.

export function ErrorModal() {
  const list = errors.value;
  useEffect(() => {
    if (!list.length) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") dismissErrors();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [list.length]);
  if (!list.length) return null;
  const cta = list.find((m) => m.cta)?.cta;
  return (
    <div class="modal-backdrop">
      <div class="modal" role="alertdialog" aria-modal="true" aria-label="Error">
        <span class="disp">{list[0]?.title ?? "Something went wrong"}</span>
        {list.map((m, i) => (
          <pre class="modal-msg" key={`${i}-${m.text}`}>
            {m.text}
          </pre>
        ))}
        <div class="modal-actions">
          {cta && (
            <a
              class="btn sm"
              href={cta.href}
              onClick={(e) => {
                e.preventDefault();
                dismissErrors();
                navigate(cta.href);
              }}
            >
              {cta.label}
            </a>
          )}
          <button type="button" class={cta ? "btn ghost sm" : "btn sm"} onClick={dismissErrors}>
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
}
